import { useLocation } from 'react-router';

import { isMlbPage } from 'constants/routes';

export const useIsMlbPage = () => {
  const location = useLocation();

  return isMlbPage(location.pathname);
};
